<app-page-header title="Krav" icon="priority_high"></app-page-header>
<div [@fadeInOut] class="page-content">
  <form #form="ngForm" [formGroup]="requirementForm" (ngSubmit)="save()" novalidate fxLayout="column" fxLayoutGap="1em" autocomplete="off">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Namn</mat-label>
            <input matInput formControlName="name" required />
            @if (getFormControl('name').hasError('required')) {
              <mat-error>Namn är obligatoriskt</mat-error>
            }
            @if (getFormControl('name').hasError('maxlength')) {
              <mat-error>Namn får inte innehålla mer än 100 tecken</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="flex-1">
            <mat-label>Verksamhetskategori</mat-label>
            <mat-select formControlName="businessCategoryId" required>
              <mat-option>{{ 'globalTexts.ChooseInstruction' | translate }}</mat-option>
              @for (entry of businessCategories$ | async; track entry) {
                <mat-option [value]="entry.item1">
                  {{ entry.item2 }}
                </mat-option>
              }
            </mat-select>
            @if (getFormControl('businessCategoryId').hasError('required')) {
              <mat-error>Verksamhetskategori är obligatorisk</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="flex-row flex-col-ltmd gap-col-1em">
          <mat-form-field class="flex-1">
            <mat-label>Beskrivning</mat-label>
            <textarea matInput rows="4" formControlName="description" required></textarea>
            @if (getFormControl('description').hasError('required')) {
              <mat-error>Beskrivning är obligatorisk</mat-error>
            }
          </mat-form-field>
        </div>
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1" [hidden]="isNew">
              <mat-label>Skapad av</mat-label>
              <input matInput [readonly]="true" value="{{ createdByName$ | async }}" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Skapad</mat-label>
              <input matInput formControlName="createdDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew && changedByName$) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad av</mat-label>
              <input matInput [readonly]="true" value="{{ changedByName$ | async }}" />
            </mat-form-field>
            <mat-form-field class="flex-1">
              <mat-label>Uppdaterad</mat-label>
              <input matInput formControlName="updatedDate" [readonly]="true" />
            </mat-form-field>
          </div>
        }
        @if (!isNew) {
          <div class="flex-row flex-col-ltmd gap-col-1em">
            <mat-form-field class="flex-1">
              <mat-label>Id</mat-label>
              <input matInput formControlName="requirementId" [readonly]="true" />
            </mat-form-field>
            <div class="flex-1">
            </div>
          </div>
        }
      </mat-card-content>
      <mat-card-actions>
        <section class="button-container">
          @if (hasPermissionToChange()) {
            <button type="submit" mat-fab color="primary" title="{{'commands.Save' | translate }}"><mat-icon>done</mat-icon></button>
          }
          <button type="button" mat-fab (click)="cancel()" color="warn" title="{{'commands.Cancel' | translate }}"><mat-icon>arrow_back</mat-icon></button>
        </section>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
